import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

import { commentsReceivedConfig } from '../commentsReceived';

export const commentsReceivedMVConfig = {
    ...commentsReceivedConfig,
    name: 'kpi.instagram.comments',
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
